import apontamentoObservacaoReport from "entity/Indicador/reports/ApontamentoObservacaoReport"
import TableReportHelper from "report/helper"
import HeaderReport from "./HeaderReport"
import apontamentoImagesReport from "entity/Indicador/reports/ApontamentoImagesReport"

export default async function Report(indicador, visita) {
    const h = new TableReportHelper(visita.data)
    const IndicadorClass = indicador.constructor

    const apontamentos = visita.getApontamentosByIndicador(indicador)

    const content = []

    for (const apontamento of apontamentos) {
        const params = visita.cliente.getParams(IndicadorClass, apontamento.tipo, indicador.type)

        content.push([
            HeaderReport(visita, indicador, apontamento, params),

            apontamentoImagesReport(visita, indicador, apontamento),
            apontamentoObservacaoReport(visita, indicador, apontamento),

            h.space(),
        ])
    }

    return content
}
